var map = {
	"./ABC.png": "D86O",
	"./ASCB.png": "FS/k",
	"./BHB.png": "eO8P",
	"./BJBANK.png": "wr/Q",
	"./BJRCB.png": "MJ29",
	"./BOC.png": "47D8",
	"./BOCD.png": "TroU",
	"./BOCY.png": "DSfT",
	"./BOCZ.png": "AF9F",
	"./BOD.png": "j2NJ",
	"./BOHAIB.png": "9IHV",
	"./BOJZ.png": "CdiJ",
	"./BOQH.png": "c3R/",
	"./BOQZ.png": "iu8v",
	"./BOYK.png": "zSOI",
	"./CABANK.png": "f7PS",
	"./CCB.png": "uG2I",
	"./CCQTGB.png": "+Od8",
	"./CDCB.png": "4S/0",
	"./CEB.png": "w25K",
	"./CIB.png": "G5Ln",
	"./CITIC.png": "smY4",
	"./CMB.png": "JRpR",
	"./CMBC.png": "2VEK",
	"./COMM.png": "wYl5",
	"./CQBANK.png": "h+cn",
	"./CRCBANK.png": "Vead",
	"./CSCB.png": "LZz7",
	"./CZBANK.png": "DV3x",
	"./CZCB.png": "OqKQ",
	"./DAQINGB.png": "+EgH",
	"./DLB.png": "6ujK",
	"./DRCBCL.png": "leqH",
	"./EGBANK.png": "Yh0M",
	"./FJHXBC.png": "3ajF",
	"./FJNX.png": "9jzR",
	"./GCB.png": "9HKs",
	"./GDB.png": "sBZ9",
	"./GLBANK.png": "EhjV",
	"./GRCB.png": "BxSr",
	"./GSBANK.png": "b9+a",
	"./GSRCU.png": "DqHq",
	"./GXNX.png": "dNA2",
	"./GYCB.png": "Id4z",
	"./GZB.png": "WFFf",
	"./GZRCU.png": "afNu",
	"./HBC.png": "xXmM",
	"./HBRCU.png": "Bvwc",
	"./HDBANK.png": "7HZ5",
	"./HKB.png": "CJnP",
	"./HNRCC.png": "Wk7i",
	"./HRBANK.png": "MYaD",
	"./HSBANK.png": "Ktjl",
	"./HURCB.png": "2HrP",
	"./HXBANK.png": "QFlF",
	"./ICBC.png": "nNOu",
	"./JJBANK.png": "xvcY",
	"./JLBANK.png": "KsME",
	"./JSBANK.png": "3AhY",
	"./JSRCU.png": "3hl6",
	"./JXRCU.png": "71Ju",
	"./LANGFB.png": "Xqco",
	"./LSBANK.png": "To4j",
	"./LSBC.png": "Z27N",
	"./LYCB.png": "Ce/x",
	"./LZYH.png": "BZ61",
	"./NBBANK.png": "7X6T",
	"./NCB.png": "a+t1",
	"./NJCB.png": "JAcu",
	"./PSBC.png": "Tk/V",
	"./QDCCB.png": "YeM1",
	"./RBOZ.png": "n5n8",
	"./RZB.png": "YNsZ",
	"./SCRCU.png": "1isd",
	"./SHBANK.png": "wYRX",
	"./SHRCB.png": "AM2k",
	"./SJBANK.png": "/7kr",
	"./SPABANK.png": "7tx3",
	"./SPDB.png": "YM1c",
	"./SRCB.png": "6Hvq",
	"./SXRCU.png": "3IPm",
	"./TCCB.png": "tQi3",
	"./TZCB.png": "iFmt",
	"./WHRCB.png": "vu4h",
	"./WZCB.png": "W7kS",
	"./XIB.png": "HO5G",
	"./XMBANK.png": "iKsw",
	"./YNRCC.png": "jbRm",
	"./ZBCB.png": "2NHw",
	"./ZJKCCB.png": "xDt7",
	"./ZJNX.png": "/GIM",
	"./ZJTLCB.png": "b/I0",
	"./ZRCBANK.png": "ZOvv",
	"./ZYB.png": "sb48",
	"./ZYCBANK.png": "YMKz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XSA3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bankLogo ^\.\/.*\.png$
// module id = XSA3
// module chunks = 0